import { render, staticRenderFns } from "./statusConfirmation.vue?vue&type=template&id=295b65b8"
import script from "./statusConfirmation.vue?vue&type=script&lang=js"
export * from "./statusConfirmation.vue?vue&type=script&lang=js"
import style0 from "./statusConfirmation.vue?vue&type=style&index=0&id=295b65b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports